import {
  FETCH_CLAIMS_ERROR,
  FETCH_CLAIMS_PENDING,
  FETCH_CLAIMS_SUCCESS,
  INIT_DISMISSED_MODALS,
  DISMISS_MODAL,
  MARK_ONBOARDING_MODAL_SHOWN,
  SET_ONBOARDING_SHOW,
} from '../actions/index';

const initialState = {
  claims: [],
  claimsLoading: false,
  isInitialized: false,
  dismissed: false,
  hasShownModal: false,
  show: undefined,
};

export default function claimsReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_DISMISSED_MODALS:
      return {
        ...state,
        isInitialized: true,
        dismissed: action.dismissed,
        show: action.show,
      };
    case DISMISS_MODAL:
      return {
        ...state,
        dismissed: true,
      };
    case MARK_ONBOARDING_MODAL_SHOWN:
      return {
        ...state,
        hasShownModal: true,
      };
    case SET_ONBOARDING_SHOW:
      return {
        ...state,
        show: action.show,
      };
    case FETCH_CLAIMS_PENDING:
      return { ...state, claimsLoading: true };
    case FETCH_CLAIMS_SUCCESS:
      return {
        ...state,
        claims: action.claims,
        claimsLoading: false,
        claimsAvailability: 'AVAILABLE',
      };
    case FETCH_CLAIMS_ERROR:
      return {
        ...state,
        claimsLoading: false,
        claimsAvailability: 'UNAVAILABLE',
      };
    default:
      return state;
  }
}
